<template>
    <v-dialog v-model="showDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon left>mdi-qrcode-scan</v-icon>
          Login via QR Code
        </v-card-title>
        
        <v-card-text class="text-center">
          <div v-if="!qrCodeUrl">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p>Gerando QR Code...</p>
          </div>
          
          <div v-else>
            <img :src="qrCodeUrl" alt="QR Code para login" 
                 style="max-width: 300px; height: 300px; object-fit: contain;">
            <p class="mt-3">Escaneie este QR Code com o app mobile para fazer login</p>
            
            <v-alert v-if="statusMessage" :type="statusType" class="mt-3" dense>
              {{ statusMessage }}
            </v-alert>
  
            <p class="caption grey--text mt-2">
              Session ID: {{ sessionId.substring(0, 8) }}...
            </p>
          </div>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeDialog">Cancelar</v-btn>
          <v-btn color="primary" @click="refreshQrCode" :loading="refreshing">
            <v-icon left>mdi-refresh</v-icon>
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import _ from 'lodash'
  export default {
    props: {
      value: Boolean
    },
    
    data() {
      return {
        qrCodeUrl: null,
        sessionId: null,
        checkInterval: null,
        statusMessage: '',
        statusType: 'info',
        refreshing: false
      }
    },
    
    computed: {
      showDialog: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    
    watch: {
      showDialog(val) {
        if (val) {
          this.generateQrCode()
        } else {
          this.cleanup()
        }
      }
    },
    
    methods: {
      async generateQrCode() {
        try {
          this.qrCodeUrl = null
          this.statusMessage = 'Gerando QR Code...'
          this.statusType = 'info'
          
          const response = await this.axios.get('/auth/qr-code')
          this.qrCodeUrl = response.data.qrCode
          this.sessionId = response.data.sessionId
          
          this.statusMessage = 'Aguardando escaneamento...'
          this.startStatusCheck()
          
        } catch (error) {
          console.error('Erro ao gerar QR Code:', error)
          this.statusMessage = 'Erro ao gerar QR Code. Tente novamente.'
          this.statusType = 'error'
        }
      },
      
      startStatusCheck() {
        this.checkInterval = setInterval(async () => {
          try {
            const response = await this.axios.get(`/auth/status/${this.sessionId}`)
            const data = response.data
            
            if (data.status === 'confirmed') {
              this.statusMessage = 'Login confirmado! Redirecionando...'
              this.statusType = 'success'
              
              // Salvar token e dados do usuário
              localStorage.setItem('auth_token', data.token)
              localStorage.setItem('user_data', JSON.stringify(data.userData))
              
              setTimeout(() => {
                this.$emit('login-success', data.userData)
                this.closeDialog()
              }, 2000)
              
              clearInterval(this.checkInterval)
            }
            
          } catch (error) {
            if (_.get(error, 'response.status') === 404) {
              this.statusMessage = 'QR Code expirado. Gere um novo.'
              this.statusType = 'warning'
              clearInterval(this.checkInterval)
            }
          }
        }, 2000) // Verificar a cada 2 segundos
      },
      
      async refreshQrCode() {
        this.refreshing = true
        this.cleanup()
        await this.generateQrCode()
        this.refreshing = false
      },
      
      cleanup() {
        if (this.checkInterval) {
          clearInterval(this.checkInterval)
          this.checkInterval = null
        }
        this.qrCodeUrl = null
        this.sessionId = null
        this.statusMessage = ''
      },
      
      closeDialog() {
        this.cleanup()
        this.showDialog = false
      }
    },
    
    beforeDestroy() {
      this.cleanup()
    }
  }
  </script>